// @flow

export const stripUnit = (unit: string, numberWithUnit: string): number =>
  +numberWithUnit.substr(0, numberWithUnit.length - unit.length);
